import { getReferrer } from '../../utils/documentReferrer';
import enqueueWithHTLBid from './enqueueWithHTLBid';
import {each, get, map} from 'lodash';
import { SOLD_CONTENT_TYPE_VALUES } from '../../constants';

export const getAdTargets = (ad_data, location) => {
  const {
    ad_sponsorship, ad_entityid, ad_pageid, ad_page_type, ad_channels,
    ad_collections, ad_is_sensitive_content,
    ad_edition, ad_keywords
  } = ad_data || {};
  const { query } = location || {};
  const { test, utm_source, utm_medium, utm_content, utm_campaign } = query || {};
  const referrer = query ? getReferrer(location) : '';
  const VERTICAL_NAME = 'r29';

  return {
    'sponsorship': ad_sponsorship,
    'section_name': ad_channels,
    'collections': ad_collections,
    'aggregations': null,
    'entityid': ad_entityid,
    'aid': ad_pageid,
    'pageid': ad_pageid,
    'pagetype': ad_page_type,
    'test': test,
    'is_sensitive_content': ad_is_sensitive_content,
    'edition': ad_edition,
    'utm_source': utm_source,
    'utm_medium': utm_medium,
    'utm_content': utm_content,
    'utm_campaign': utm_campaign,
    'vertical': VERTICAL_NAME,
    'document.referrer': referrer,
    'keywords': ad_keywords
  };
};

export default (store, location) => new Promise(resolve => {
  const { ad_data } = store.getState().ads;
  const { ad_page_type } = ad_data;
  const { article } = store.getState();

  enqueueWithHTLBid(() => {
    const pubads = window.htlbid.pubads();
    const soldContentType = get(article, 'meta.sold_content_type', null);

    const adTargets = getAdTargets(ad_data, location);
    const pluginTargets = {
      'pagetype': ad_page_type,
      'sold_content_type': soldContentType ? SOLD_CONTENT_TYPE_VALUES[soldContentType] : null
    };
    const targeting = {
      ...adTargets,
      ...pluginTargets
    };

    each(targeting, (val, target) => {
      const attribute = Array.isArray(val)
        ? val.map(String)
        : String(val);

      pubads.setTargeting(target, attribute);
    });

    window.htlbid = window.htlbid || {};
    window.htlbid.cmd = window.htlbid.cmd || [];

    window.htlbid.cmd.push(() => {
      window.htlbid.enableServices();
      window.htlbid.layout();
    });


    resolve();
  });
});
